<div class="customer-agents-info">
  <div class="heading">
    <div>
      <span>{{ 'label.CustomerAgents' | translate }}</span>
    </div>
    <div>
      <a
        *ngIf="customer?.statusId == customerStatusEnum.Active"
        [routerLink]="
          customer ? ['/customers/edit/', customer?.customerId, 'agents'] : []
        "
        >{{ 'label.Edit' | translate }}</a
      >
    </div>
  </div>
  <div class="content">
    <table class="list">
      <thead>
        <tr>
          <th>{{ 'label.Name' | translate }}</th>
          <th>{{ 'label.Surname' | translate }}</th>
          <th>{{ 'label.Email' | translate }}</th>
          <th>{{ 'label.PhoneNumber' | translate }}</th>
          <th>{{ 'label.Status' | translate }}</th>
          <th>{{ 'label.Position' | translate }}</th>
          <th>{{ 'label.ProfileOwner' | translate }}</th>
          <th>{{ 'label.Date' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of customer?.agentList">
          <td>{{ item.name }}</td>
          <td>{{ item.surname }}</td>
          <td>{{ item.email }}</td>
          <td>
            <span *ngIf="item.phoneNumber"
              >{{ item.phoneNumber }}
              <span *ngIf="item.phoneNumberExtension"
                >({{ item.phoneNumberExtension }})</span
              ></span
            >
            <span *ngIf="item.mobilePhoneNumber"
              ><br />{{ item.mobilePhoneNumber }}</span
            >
            <span *ngIf="item.mobilePhoneNumber2"
              ><br />{{ item.mobilePhoneNumber2 }}</span
            >
          </td>
          <td>{{ item.status }}</td>
          <td>{{ item.position }}</td>
          <td>
            <div [hidden]="!item.isProfileOwner">
              <span class="fa fa-chevron-down"></span>
            </div>
          </td>
          <td>
            {{ item.createDate | date : dateFormat }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
